import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  customizeYourAgentTitle: {
    id: 'page-topper.customize-your-ai-message.text.title.non-final',
    defaultMessage: 'Customize your Agent',
    description: 'Title for section in config panel that is shown when an AI agent is enabled'
  },
  customizeYourAgentDescription: {
    id: 'page-topper.customize-your-ai-message.text.description.non-final',
    defaultMessage: 'Your agent’s display on your hub is determined by your settings in Customer Service Manager.',
    description: 'Description for section in config panel that is shown when an AI agent is enabled'
  },
  customizeYourAgentLink: {
    id: 'page-topper.customize-your-ai-message.text.link.non-final',
    defaultMessage: 'Go to CSM',
    description: 'Link text that navigates user to CSM to customize their AI agent display settings'
  }
});